import { noop } from '@gem/utils';

import { handleBackgrounds } from 'APP/Tasks/authorization/login/handleClientConfig/handlers/handleBackgrounds';
import { handleRewardsStatus } from 'APP/Tasks/authorization/login/handleClientConfig/handlers/handleRewardsStatus';
import { handleWhitelistHosts } from 'APP/Tasks/authorization/login/handleClientConfig/handlers/handleWhitelistHosts';
import { ClientConfigKey, IClientConfigItem } from 'APP/model/auth/authModel.types';

import { handleAdminAuthUrlBase } from './handlers/handleAdminAuthUrlBase';
import { handleCoinfideHost } from './handlers/handleCoinfideHost';
import { handleForceUpdate } from './handlers/handleForceUpdate';
import { handleMarketspaceAvailable } from './handlers/handleMarketspaceAvailable';
import { handleMaxParticipants } from './handlers/handleMaxParticipants';
import { handleMessageKeywords } from './handlers/handleMessageKeywords';
import { handleMyStickers } from './handlers/handleMyStickers';
import { handleOnboarding } from './handlers/handleOnboarding';
import { handleReactions } from './handlers/handleReactions';
import { handleSoftUpdate } from './handlers/handleSoftUpdate';
import { handleStickers } from './handlers/handleStickers';
import { handleSupportEmail } from './handlers/handleSupportEmail';
import { handleTelegramConfig } from './handlers/handleTelegramConfig';
import { handleUserPreferences } from './handlers/handleUserPreferences';

// TODO: add typings
const HANDLERS: Record<ClientConfigKey, (payload: any) => Promise<void> | void> = {
  [ClientConfigKey.ForcedUpdate]: handleForceUpdate,
  [ClientConfigKey.SoftUpdate]: handleSoftUpdate,
  [ClientConfigKey.MessagesKeywords]: handleMessageKeywords,
  [ClientConfigKey.CallParticipantsMax]: handleMaxParticipants,
  [ClientConfigKey.ReactionsLastUpdateTimestamp]: handleReactions,
  [ClientConfigKey.StickersLastUpdateTimestamp]: handleStickers,
  [ClientConfigKey.UserStickersLastUpdateTimestamp]: handleMyStickers,
  [ClientConfigKey.UserPreferences]: handleUserPreferences,
  [ClientConfigKey.FeatureMarketSpace]: handleMarketspaceAvailable,
  [ClientConfigKey.RewardsStatus]: handleRewardsStatus,
  [ClientConfigKey.CoinfideHost]: handleCoinfideHost,
  [ClientConfigKey.Onboarding]: handleOnboarding,
  [ClientConfigKey.WhitelistUrls]: handleWhitelistHosts,
  [ClientConfigKey.TelegramAuth]: handleTelegramConfig,
  [ClientConfigKey.SupportEmail]: handleSupportEmail,
  [ClientConfigKey.AdminAuthUrlBase]: handleAdminAuthUrlBase,
  [ClientConfigKey.Backgrounds]: handleBackgrounds,
  // TODO: add handlers for the following keys
  [ClientConfigKey.SupportedSDKVersion]: noop,
  [ClientConfigKey.VideoAutoplay]: noop,
  [ClientConfigKey.CallsProvider]: noop,
};

// TODO: Refactor handlers
export function handleClientConfig(clientConfigItems: IClientConfigItem[]): void {
  clientConfigItems.forEach((item) => {
    const handler = HANDLERS[item.key];

    if (!handler) {
      return;
    }

    handler(item.payload);
  });
}
